import axios from 'axios';
import { getCsrftoken } from '../../helpers/csfrToken';
import { restErrorHandler } from '../../helpers/restErrorHandler';
import { RestApiState } from '../../interfaces/Rest/types';


export type Building = {
    id: number;
    address: string;
    building_name: string;
    building_image: string | null;
    responsible_name: string;
    responsible_phone: string;
    organization_id: number;
}

export type EditBuilding = {
    building_id?: number;
    address: string;
    building_name: string;
    building_image?: File | null;
    responsible_name?: string;
    responsible_phone?: string;
    organization_id?: number;
}

interface RequestProps {
    role: string;
    key: string;
    action: string;
    organization_id?: string;
    setter: (action: string, key: string, value: any) => void
}

export const FetchOwnBuildingList =  async ({ role, action, key, setter }: RequestProps) => {
    axios.get<Building[]>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/building/list`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            try {
                setter(action, key, response.data)
            } catch {
                console.log('err')
            }
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}


export const FetchOrganizationBuildingList = ({ role, action, key, setter, ...props }: RequestProps) => {
    if (!props.organization_id) {
        throw new Error("Organization ID must be provided")
    }
    axios.get<Building[]>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/building/organization/${props.organization_id}/list`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            try {
                setter(action, key, response.data)
            } catch {
                console.log('err')
            }
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}


export type CreateBuildingType = {
    address: string;
    building_name: string;
    building_image?: File | null;
}

interface CreateRequestProps {
    role: string;
    setStatus: (value: any) => void;
    setValue: (value: any) => void;
    data: CreateBuildingType;
}

export const CreateBuilding = async ({ role, setStatus, setValue, data }: CreateRequestProps) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.post<Building>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/building/create`, data, headers
    )
    .then(response => {
        if (response.status === 201) {
            setStatus(RestApiState.Success)
            setValue(response.data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}

export const StaffCreateBuilding = async ({ role, setStatus, setValue, data }: CreateRequestProps) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.post<Building>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/building/create`, data, headers
    )
    .then(response => {
        if (response.status === 201) {
            setStatus(RestApiState.Success)
            setValue(response.data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}

interface UpdateRequestProps {
    role: string;
    setStatus: (value: any) => void;
    setValue: (value: any) => void;
    building: EditBuilding;
}

export const UpdateBuilding = ({ role, setStatus, setValue, building }: UpdateRequestProps) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }

    axios.patch<Building>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/building/${building.building_id}/detail`, building, headers)
    .then(response => {
        if (response.status === 200) {
            try {
                setStatus(RestApiState.Success)
                setValue(response.data)
                console.log("response",response.data)
            } catch {
                console.log('err')
            }
        }
    })
    .catch(error => {
        console.log(error)
        // restErrorHandler(error.status)
    });
}

interface DeleteRequestProps {
    role: string;
    setStatus: (value: any) => void;
    setValue: (value: any) => void;
    buildingId: number;
}

export const DeleteBuilding = ({ role, setStatus, setValue, buildingId }: DeleteRequestProps) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.delete<Building[]>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/building/${buildingId}/detail`, headers
    )
    .then(response => {
        if (response.status === 204) {

            setStatus(RestApiState.Success)
            setValue(buildingId)
        }
    })
    .catch(error => {
        console.log(error)
        // restErrorHandler(error.status)
    });
}